import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    accessGroupUserList: {
      requesting: false,
      items: [],
      pagination: {
		  current_page: 1,
		  per_page: 10,
		  total: 0,
	  },
      error: null,
      success: false,
      filters: {},
    },
    accessGroupUserDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const accessGroupUserSlice = createSlice({
  name: 'accessGroupUser',
  initialState,
  reducers: {
    getAccessGroupUserList: (state, action) => {
        state.accessGroupUserList.requesting = true;
        state.accessGroupUserList.error = null;
        state.accessGroupUserList.items = [];
        state.accessGroupUserList.success = false;
        state.accessGroupUserList.filters = action.payload;
    },
    getAccessGroupUserListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.accessGroupUserList.requesting = false;        
        state.accessGroupUserList.items = data;
        state.accessGroupUserList.success = true; 
        state.accessGroupUserList.pagination.current_page = current_page;
        state.accessGroupUserList.pagination.per_page = per_page;
        state.accessGroupUserList.pagination.total = total;
    },
    getAccessGroupUserListFail: (state, action) => {        
        state.accessGroupUserList.requesting = false;
        state.accessGroupUserList.error = action.payload;
    },
    getAccessGroupUserDetails: (state) => {
        state.accessGroupUserDetails.requesting = true;
        state.accessGroupUserDetails.error = null;
        state.accessGroupUserDetails.data = null;
        state.accessGroupUserDetails.success = false; 
    },
    getAccessGroupUserDetailsSuccess: (state, action) => {
        state.accessGroupUserDetails.requesting = false;
        state.accessGroupUserDetails.data = action.payload;
        console.log(action);
        state.accessGroupUserDetails.success = true; 
    },
    getAccessGroupUserDetailsFail: (state, action) => {        
        state.accessGroupUserDetails.requesting = false;
        state.accessGroupUserDetails.error = action.payload;
    },
    doAccessGroupUserCreate: (state) => {
        state.accessGroupUserDetails.requesting = true;
        state.accessGroupUserDetails.error = null;
        state.accessGroupUserDetails.data = null;
        state.accessGroupUserDetails.success = false; 
    },
    doAccessGroupUserUpdate: (state) => {
        state.accessGroupUserDetails.requesting = true;
        state.accessGroupUserDetails.error = null;
        state.accessGroupUserDetails.data = null;
        state.accessGroupUserDetails.success = false; 
    },
    doAccessGroupUserDelete: (state) => {
        state.accessGroupUserDetails.requesting = true;
        state.accessGroupUserDetails.error = null;
        state.accessGroupUserDetails.data = null;
        state.accessGroupUserDetails.success = false; 
    },
  },
})

export const { 
    getAccessGroupUserList, getAccessGroupUserListSuccess, getAccessGroupUserListFail,
    getAccessGroupUserDetails, getAccessGroupUserDetailsSuccess, getAccessGroupUserDetailsFail,
    doAccessGroupUserCreate, doAccessGroupUserUpdate, doAccessGroupUserDelete
} = accessGroupUserSlice.actions

export default accessGroupUserSlice.reducer